import * as yup from 'yup';

export const hpdTicketSchema = yup.object().shape({
  date: yup.string().required("Date is required"),

  violation_code: yup.string().required("Violation Code is required"),

  building_id: yup.string().required("Building is required"),

  unit_id: yup.string().required("Apt# is required"),

  violation_id: yup.number()
    .required("Violation # is required")
    .test(
      'len', 
      'Violation # cannot exceed 10 digits', 
      val => !val || val.toString().length <= 10
    ),

  correct_by_date: yup.string().required("Correct Date is required"),

  certify_by_date: yup.string().required("Certify Date is required"),

  description: yup.string().nullable(),
});

export default hpdTicketSchema;